/**
 * Vendor
 */
import React from 'react';

/**
 * CARIBE7 MODULES
 */
import BaseAlertService from '@shared/services/base/alerts/BaseAlertService';

/**
 * Error Alert Service
 *
 * @class      ErrorAlertService (name)
 */
function ErrorAlertService(component) {
  this.component   = component;
}

ErrorAlertService.prototype = Object.assign(ErrorAlertService.prototype, BaseAlertService.prototype);

/**
 * Registers Alert events, this follows naming convention
 *
 * @param      {Object}       self         The caller instance
 * @param      {BaseService}  service      The service
 * @param      {string}       module_name  The module name
 */
ErrorAlertService.prototype.registerErrorAlertEvents = function(self, service) {
  var event_callback_map = {};
  event_callback_map[this.event_group.ERROR_DISPLAY] = 'onErrorDisplay';
  event_callback_map[this.event_group.ERROR_SUCCESS] = 'onErrorSuccess';
  event_callback_map[this.event_group.ERROR_FAIL]    = 'onErrorFail';
  this.registerEvents(event_callback_map, service);
  return this;
}

/**
 * Removes Alert events.
 *
 * @param      {<type>}  self         The object
 * @param      {<type>}  service      The service
 * @param      {string}  module_name  The module name
 */
ErrorAlertService.prototype.removeErrorAlertEvents = function() {
  this.removeEvents([
    this.event_group.ERROR_DISPLAY,
    this.event_group.ERROR_SUCCESS,
    this.event_group.ERROR_FAIL
  ]);
  return this;
}


/**
 * Called when error alert display
 *
 * @param      {Object}  arg1       The argument 1
 * @param      {<type>}  arg1.data  The data
 */
ErrorAlertService.prototype.onErrorDisplay = function({
  title='Error',
  message='',
  options={},
  onConfirm,
  onResolve,
  onError
}) {
  this.createSwal({
    props: {
      title:   <span>{title}</span>,
      html:    message,
      icon:    'error',
    },
    options: options,
    onConfirm: onConfirm,
    onResolve: onResolve,
    onError: onError,
  });
};

/**
 * Called on Regsiter success.
 *
 * @param      {object}  response  The response
 */
ErrorAlertService.prototype.onErrorSuccess = function(response) {
  console.log("ErrorAlertService::onErrorSuccess", response);
}

/**
 * Called on Regsiter fail.
 *
 * @param      {object}  error   The error
 */
ErrorAlertService.prototype.onErrorFail = function(error) {
  console.log("ErrorAlertService::onErrorFail", error);
}

export default ErrorAlertService;